/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import PropTypes from "prop-types";
import "./themeActionButton.css";

function ThemeActionButton(props) {
  const {
    wait, disabled, onClick, buttonText,
  } = props;
  return (
    <span style={{
      cursor: (() => {
        if (wait) return "wait";
        if (disabled) return "default";
        return "pointer";
      })(),
    }}
    >
      <div
        onKeyDown={() => {
          // onKeyDown
        }}
        data-testid="theme-action"
        className={`theme-button-container ${(disabled || wait) && "theme-button-container-disabled"}`}
        onClick={onClick}
        style={{ pointerEvents: (disabled || wait) ? "none" : "auto" }}
      >
        <div className="actionbutton">
          <span>{buttonText}</span>
        </div>
      </div>
    </span>
  );
}

ThemeActionButton.defaultProps = {
  className: "",
  buttonText: "",
  onClick: () => {
    // onClick
  },
  disabled: false,
  wait: false,
};

ThemeActionButton.propTypes = {
  className: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  wait: PropTypes.bool,
};

export default ThemeActionButton;
